import FilledCartProduct from '../../../api/models/FilledCartProduct'
import Store from 'api/models/Store'

export type MissingProduct = {
  _id: string,
  name: string,
  expectedQuantity: number,
  availability: number
}

export function getMissingProductInFilledCart(filledCart: FilledCartProduct[], activeStore: Store): MissingProduct[] {
  return filledCart
    .map(item => new FilledCartProduct(item))
    .flatMap(item => {
      const product = activeStore.findProductById(item._id)
      if (product) {
        if (item.isNotAvailable()) {
          return {
            _id: product.getId(),
            name: product.getName(),
            expectedQuantity: item.quantity,
            availability: 0
          }
        }
        if (item.isLowerStock()) {
          return {
            _id: product.getId(),
            name: product.getName(),
            expectedQuantity: item.quantity,
            availability: item.getMaxAvailableQuantity() || 0
          }
        }
      }
      return [];
    })
}
